function isRouteSuccessor(pathname, href) {
  if (!href) return false;
  const prefix = href.endsWith('/') ? href : `${href}/`;
  return pathname === href || pathname.startsWith(prefix);
}

function collectHrefs(items) {
  if (!Array.isArray(items)) return [];
  return items.flatMap(item => [item?.href, ...collectHrefs(item?.items)]).filter(Boolean);
}

function isUniversalRoot(href, allHrefs) {
  return allHrefs.length > 1 && allHrefs.every(other => isRouteSuccessor(other, href));
}

function longestMatchingHrefLength(items, pathname, rootHrefs) {
  const lengths = collectHrefs(items)
    .filter(href => (rootHrefs.has(href) ? pathname === href : isRouteSuccessor(pathname, href)))
    .map(href => href.length);

  return lengths.length ? Math.max(...lengths) : -1;
}

export function hasActiveDescendant(items, pathname) {
  return collectHrefs(items).includes(pathname);
}

export function findActiveCategoryIndex(categories, pathname) {
  if (!Array.isArray(categories)) {
    console.warn('findActiveCategoryIndex: categories is not an array', categories);
    return -1;
  }

  const allHrefs = categories.flatMap(category => collectHrefs(category?.items));
  const rootHrefs = new Set(allHrefs.filter(href => isUniversalRoot(href, allHrefs)));

  let bestIndex = -1;
  let bestLength = -1;

  categories.forEach((category, index) => {
    const length = longestMatchingHrefLength(category?.items, pathname, rootHrefs);
    if (length > bestLength) {
      bestLength = length;
      bestIndex = index;
    }
  });

  return bestIndex;
}
